const obj_rm_empty = (obj, options = {}) => {
	// Handle null/undefined input
	if (!obj) return obj;
	
	// Preserve Firestore FieldValue objects (like serverTimestamp())
	if (options.exc_instof) {	
		// Handle array of types
		if (Array.isArray(options.exc_instof)) {
			for (const type of options.exc_instof) {
				if (obj instanceof type) return obj;
			}
		}
		// Handle single type
		else if (obj instanceof options.exc_instof) {
			return obj;
		}
	}
	
	// Handle non-objects
	if (typeof obj !== 'object') return obj;
	
	// Handle arrays
	if (Array.isArray(obj)) {
		return obj
			.map(item => obj_rm_empty(item, options))
			.filter(item => item != null);
	}

	// Handle objects
	return Object.entries(obj).reduce((acc, [key, value]) => {
		// Recursively clean nested objects/arrays
		const cleanValue = obj_rm_empty(value, options);
		
		// Skip null/undefined values unless null_to_str is true
		if (cleanValue == null) {
			if (options.null_to_str) {
				acc[key] = 'null';
			}
			return acc;
		}

		// Keep non-null values
		acc[key] = cleanValue;
		return acc;
	}, {});
}
	

export default obj_rm_empty